const ASSETS = "/assets/gledswood";

export const CEREMONY_LOCATIONS = [
  ["Lakeside Lawn", "White folding chairs are included for this location."],
  ["Hennery Lawn", "Mismatched timber chairs are included for this location."],
  ["Shearing Shed", "An indoor ceremony location for your event."],
  ["Offsite", "An offsite ceremony location."],
];

export const ARBOURS = [
  {
    key: "hexagonal",
    name: "Hexagonal Arbour",
    image: `${ASSETS}/hexagonal-arbour.jpg`,
    description: "Geometric six-sided arch — a popular modern choice.",
  },
  {
    key: "triangular",
    name: "Triangular Arbour",
    image: `${ASSETS}/triangular-arbour.jpg`,
    description: "Striking triangular geometric arch for contemporary ceremonies.",
  },
  {
    key: "timber_rectangle",
    name: "Timber Rectangle Arbour",
    image: `${ASSETS}/timber-rectangle-arbour.jpg`,
    description: "Warm natural timber rectangle — heritage feel.",
  },
  {
    key: "white_rectangle",
    name: "White Rectangle Arbour",
    image: `${ASSETS}/white-rectangle-arbour.jpg`,
    description: "Clean painted white rectangle — classic luxury.",
  },
  {
    key: "isabella",
    name: "Isabella Arbour",
    image: `${ASSETS}/isabella-arbour.jpg`,
    description: "Our signature Isabella arbour — elegant arched form.",
  },
  {
    key: "florist",
    name: "Florist Providing Arbour",
    image: `${ASSETS}/florist-providing-arbour.jpg`,
    description: "Your florist supplies and styles the arbour.",
  },
  {
    key: "client",
    name: "Client Providing Arbour",
    image: `${ASSETS}/client-providing-arbour.jpg`,
    description: "You're bringing your own arbour — let us know the details.",
  },
  {
    key: "none",
    name: "No Arbour",
    image: `${ASSETS}/no-arbour.jpg`,
    description: "An open ceremony without an arbour.",
  },
];

export const CEREMONY_LOCATION_NAMES = CEREMONY_LOCATIONS.map(([name]) => name);
export const ARBOUR_NAMES = ARBOURS.map((option) => option.name);
